module.exports = __webpack_public_path__ + "media/2_2-2.834e7f08.mp3";